export default __webpack_public_path__ + "static/media/vegan.ad9667d5.png";